import { render } from "./TheNotification.vue?vue&type=template&id=57245a58"
import script from "./TheNotification.vue?vue&type=script&lang=js"
export * from "./TheNotification.vue?vue&type=script&lang=js"
script.render = render

export default script